import PropTypes from 'prop-types';
import React from 'react';
import SplitLayout from '../common/layouts/splitLayout';
import GoButton from '../common/components/GoButton';
import StimulusButton from '../common/stimulus/StimulusButton';
import AudioContainer from '../common/audio/audioContainer';
import ScreenErrorContainer from '../common/error/ScreenErrorContainer';
import Illustration from '../common/illustration/Illustration';
import ImageAudioAnswer from '../common/components/ImageAudioAnswer';

export default class IPSView extends React.Component {
    componentDidMount() {
        if (!this.props.isDataFetched) {
            this.props.fetchContent();
        } else {
            this.props.narrateScreen(
                this.props.questionSpecificAudio,
                this.props.stimulusAudio,
                this.props.possibleResponses,
            );
            this.props.setAvatarInstructions(this.props.questionSpecificAudio);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.narrationShouldStart(prevProps)) {
            this.props.narrateScreen(
                this.props.questionSpecificAudio,
                this.props.stimulusAudio,
                this.props.possibleResponses,
            );
            this.props.setAvatarInstructions(this.props.questionSpecificAudio);
        }
    }

    componentWillUnmount() {
        this.props.cleanup();
    }

    getStimulusArea = () => (
        <div>
            <StimulusButton
                isDisabled={this.props.isGreyedOut}
                isPlaying={this.props.isStimulusPlaying}
                onClick={this.playStimulus} />
            <Illustration
                altText="stimulus-img"
                url={this.props.stimulusImage}
                class="stimulus-illustration" />
        </div>
    )

    getSelectedResponseCallback = (index) => () => {
        this.props.selectResponse(index);
    }

    getResponseAudioCallback(audio, index) {
        return () => {
            this.props.responseAudioClick(audio, index);
        };
    }

    getResponseOption({ id, audio, image }, index) {
        return (
            <ImageAudioAnswer
                isDisabled={this.props.isGreyedOut}
                key={id}
                isSelected={(id === this.props.selectedIndex)}
                isStimulusSelected={(index === this.props.playingResponseIndex)}
                onAnswerClick={this.getSelectedResponseCallback(id)}
                onStimulusClick={this.getResponseAudioCallback(audio, index)}
                image={image} />
        );
    }

    getResponsesArea() {
        return (
            <div className="vertical-answer-buttons">
                {
                    this.props.possibleResponses.map((answer, index) => this.getResponseOption(answer, index), this)
                }
            </div>
        );
    }

    playStimulus = () => {
        if (this.props.stimulusAudio) {
            this.props.narrateStimulus(this.props.stimulusAudio);
        }
    }

    narrationShouldStart(prevProps) {
        const isReady = this.props.isDataFetched;
        const shouldStartNarrate = (
            this.props.isDataFetched !== prevProps.isDataFetched
            || this.props.questionIndex !== prevProps.questionIndex
        );
        return isReady && shouldStartNarrate;
    }

    render() {
        return (
            <SplitLayout
                class={this.props.pageLayout}
                isScreenBlocked={this.props.isScreenBlocked}
                isGreyedOut={this.props.isGreyedOut}
                isFetching={false}
                upperElement={this.getStimulusArea()}
                lowerElement={this.getResponsesArea()}>
                <ScreenErrorContainer onRetry={this.props.onNext} />
                {(this.props.isNextButtonVisible)
                    && (
                        <GoButton
                            onClick={this.props.onNext}
                            isEnabled={!this.props.isScreenBlocked} />
                    )}
                <AudioContainer />
            </SplitLayout>
        );
    }
}

IPSView.propTypes = {
    pageLayout: PropTypes.string,
    isStimulusPlaying: PropTypes.bool,
    isScreenBlocked: PropTypes.bool,
    isNextButtonVisible: PropTypes.bool,
    questionIndex: PropTypes.number,
    selectedIndex: PropTypes.number,
    playingResponseIndex: PropTypes.number,
    possibleResponses: PropTypes.array,
    stimulusAudio: PropTypes.string,
    stimulusImage: PropTypes.string,
    questionSpecificAudio: PropTypes.string,
    isGreyedOut: PropTypes.bool,
    isDataFetched: PropTypes.bool,
    selectResponse: PropTypes.func,
    responseAudioClick: PropTypes.func,
    narrateStimulus: PropTypes.func,
    setAvatarInstructions: PropTypes.func,
    fetchContent: PropTypes.func,
    narrateScreen: PropTypes.func,
    onNext: PropTypes.func,
    cleanup: PropTypes.func,
};

IPSView.defaultProps = {
    pageLayout: '',
    isStimulusPlaying: false,
    isScreenBlocked: false,
    isNextButtonVisible: false,
    questionIndex: undefined,
    selectedIndex: undefined,
    playingResponseIndex: undefined,
    possibleResponses: [],
    stimulusAudio: undefined,
    stimulusImage: '',
    questionSpecificAudio: undefined,
    isGreyedOut: false,
    isDataFetched: false,
    selectResponse: () => {},
    responseAudioClick: () => {},
    narrateStimulus: () => {},
    setAvatarInstructions: () => {},
    fetchContent: () => {},
    narrateScreen: () => {},
    onNext: () => {},
    cleanup: () => {},
};
